import { createAction, props } from "@ngrx/store";
import { IProjectUser } from "../core/models/project-user.vm";

export const loadAdminUsers = createAction("[User List] Load Admin Users");
export const loadAdminUsersSuccess = createAction("[User List] Load Admin Users Success", props<{userlist: IProjectUser[]}>());
export const loadAdminUsersError = createAction("[User List] Load Admin Users Error");